// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__2uiln","left":"InfoRow_left__1mpzr"};